import {TemplateList} from "~/libs/constants/TemplateList"
import {RecombeeScenariosConfig} from "~/config/RecombeeScenariosConfig"
import type RecombeeScenarioItem from "~/libs/interfaces/RecombeeScenarioItem"
import {RecommendPlacementId} from "~/libs/constants/RecommendPlacementId"
import {useUniWebTemplate} from "~/composables/useUniWebTemplate";

export const useRecombeeScenariosConfig = () => {
  const getScenariosConfig = ():RecombeeScenarioItem[] => {
    return useUniWebTemplate().getTemplateListItem() !== null ? RecombeeScenariosConfig[useUniWebTemplate().getTemplateListItem() as TemplateList] : []
  }

  const getScenarioConfigByPlacementId = (type?: RecommendPlacementId):RecombeeScenarioItem | undefined => {
    if (!type) {
      return
    }

    const config = getScenariosConfig()

    for(let item of config) {
      if (item.placementId === type) {
        return item
      }
    }
  }

  return {
    getScenariosConfig,
    getScenarioConfigByPlacementId
  }
}


